import { useQuery } from "@tanstack/react-query";
import { IndexerFailures } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const INDEXER_FAILURES_COUNT_QUERY_KEY = "indexer_failures_count";
const useIndexerFailuresCount = (since) => {
  const { data, isLoading } = useQuery({
    queryKey: [INDEXER_FAILURES_COUNT_QUERY_KEY, since],
    queryFn: () => defaultOnError(
      IndexerFailures.count(since),
      "Loading indexer failures count failed with status",
      "Could not load indexer failures count"
    )
  });
  return {
    data: data == null ? void 0 : data.count,
    isLoading
  };
};
export default useIndexerFailuresCount;
